// React
import React from "react";

// Core
import { getHistory } from "../../Core/Utils/Utils";

// Material-UI (Core)
import { Box, Typography } from "@material-ui/core";

// Custom
import styled from "styled-components";

// Strips hoverColour before it reaches the DOM to avoid React unknown prop warning
const FilteredBox = ({ hoverColour, ...rest }: React.ComponentProps<typeof Box> & { hoverColour?: string }) => <Box {...rest} />;

const StyledBlock = styled(FilteredBox)<{ disabled?: boolean; hoverColour?: string }>`
    display: flex;
    transition: all 0.3s ease;
    gap: 0;
    position: relative;
    cursor: ${props => (props.disabled ? "not-allowed" : "pointer")};
    opacity: ${props => (props.disabled ? 0.5 : 1)};
    ${props =>
        props.hoverColour &&
        `
        &:hover svg path { fill: ${props.hoverColour} !important; }
        &:hover p { color: ${props.hoverColour} !important; }
    `}
`;


interface FooterBlockProps {
    icon?: any;
    title: string;
    path?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
    height?: string;
    width?: string;
    disabled?: boolean;
    showIndicator?: boolean;
    hoverColour?: string;
}

export const FooterMenuBlock: React.FC<FooterBlockProps> = props => {
    const gotoPageCommand = () => {
        if (props.disabled) {
            return; // Don't navigate if disabled
        }
        if (props.path) {
            getHistory().push(props.path);
        }
    };

    return (
        <StyledBlock id={"footerblock"} onClick={gotoPageCommand} style={props.style!} disabled={props.disabled} hoverColour={props.hoverColour}>
            <Box position={"relative"}>
                {props.icon && <props.icon width={props.width} height={props.height} />}
                {props.showIndicator && (
                    <Box
                        style={{
                            marginLeft: 8,
                            width: 10,
                            height: 10,
                            borderRadius: "50%",
                            backgroundColor: "#3aaa35",
                            position: "absolute",
                            right: "0px",
                            top: "-4px",
                        }}
                    />
                )}

                <Box>
                    <Typography>{props.title}</Typography>
                </Box>
            </Box>
        </StyledBlock>
    );
};
